import React from 'react';
import { money } from '../helpers';
import { TOKENS } from '../styles';

export interface BreakdownRow {
  label: string;
  amount: number;
}

interface Props {
  rows: BreakdownRow[];
  total: number;
}

export default function BreakdownPanel({ rows, total }: Props) {
  return (
    <div style={{
      background: '#F7F9FA',
      border: '1px solid ' + TOKENS.line,
      borderRadius: 10,
      margin: '8px 0 0 4px',
      padding: '12px 18px',
    }}>
      {rows.map((r, i) => (
        <div key={i} style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '4px 0',
          color: TOKENS.dark,
          fontSize: 13,
          fontWeight: 600,
        }}>
          <span>{r.label}</span>
          <span style={{ fontVariantNumeric: 'tabular-nums' }}>{money(r.amount)}</span>
        </div>
      ))}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px 0 4px',
        color: TOKENS.ink,
        fontSize: 13,
        fontWeight: 700,
        borderTop: '1px solid ' + TOKENS.line,
        marginTop: 4,
      }}>
        <span>Total</span>
        <span style={{ fontVariantNumeric: 'tabular-nums' }}>{money(total)}</span>
      </div>
    </div>
  );
}